import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { ListChecks } from 'lucide-react';
import { ComplaintIndicators } from './ComplaintIndicators';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/complaints/rules')({
    staticData: {
        metadata: {
            title: 'Rules',
        },
        ui: {
            icon: ListChecks,
            title: 'Complaint rules',
            subtitle: 'Indicator rules that flag complaints by milestone and timing',
            menuDescription: 'Indicator rules that flag complaints by milestone and timing',
        },
    },
    component: ComplaintsRules,
});

function ComplaintsRules() {
    return (
        <PageController route={Route}>
            <ComplaintIndicators />
        </PageController>
    );
}
